import type { ErrorEvent, StackFrame } from '@sentry/angular';

const pageAddress = /^(https?:\/\/|\/)/;
const scriptFile = /\.m?js([?#].*)?$/;

const isInPage = (frame: StackFrame) =>
  !!frame.filename && pageAddress.test(frame.filename) && !scriptFile.test(frame.filename);

/** True when every stack frame points at the page itself, i.e. a script the browser put into the page, not ours. */
export function isFromInjectedScript(event: ErrorEvent): boolean {
  const frames = event.exception?.values?.flatMap((exception) => exception.stacktrace?.frames ?? []) ?? [];
  return frames.length > 0 && frames.every(isInPage);
}
